import { createEvent } from "effector";
import { DegradedModeDTO } from "@state/degraded/dto/response/degraded.mode.dto";

export const degradedContextEvent = createEvent<DegradedModeDTO | undefined>();
